
import axios from 'axios';


async function getAllDevices() {
    let response = (await axios.get(`${process.env.VUE_APP_APIURL}/device`, { params: { all: 'true' } })).data;
    let devices = response.devices || [];
    return devices;

}

function getDevices(value) {
    return axios.get(`${process.env.VUE_APP_APIURL}/device`, { params: { macAddress: value } })
        .then(resp => {
            return resp.data.devices;
        });
}

function getRoutingLookup(macAddress) {
    return axios.get(`${process.env.VUE_APP_APIURL}/iot/device/${macAddress}/routingLookup`,)
        .then(resp => {
            return resp;
        });
}

export default {
    getDevices,
    getRoutingLookup,
    getAllDevices
};